import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  RunAgentMutation,
  RunAgentMutationVariables,
} from '#/graphql/generated';

export const RUN_AGENT: TypedDocumentNode<
  RunAgentMutation,
  RunAgentMutationVariables
> = gql`
  mutation RunAgent($id: String!) {
    runAgent(id: $id) {
      queued
      message
      taskName
      agent {
        id
        lastRunAt
        updatedAt
      }
    }
  }
`;
